module.exports = __webpack_public_path__ + "img/alex2.a8fbcd16.png";